import React from 'react'
import Fade from '@material-ui/core/Fade'
import MerchantCard from '../../Cards/MerchantCard'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 207,
        alignSelf: 'center',
        textAlign: 'center',
        margin: '1.5rem 0',
    },
    titleText: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginTop: '0',
    },
    subtitleText: {
        marginTop: '.5rem',
    },
    navigateButton: {
        textTransform: 'none',
        fontSize: '1.1rem',
        maxWidth: 207,
        padding: '1rem',
        marginBottom: '1rem',
        marginTop: '1rem',
    },
}))

const EmptyCartBuyCardItem = ({
    pageUrl,
    imageUrl,
    imageTitle,
    title,
    subtitle,
    buttonText,
}) => {
    const classes = useStyles()

    return (
        <Box className={classes.root}>
            <Fade in timeout={300}>
                <>
                    <a href={pageUrl}>
                        <MerchantCard
                            width={207}
                            height={126}
                            imageSrc={imageUrl}
                            title={imageTitle}
                            lazyLoad={true}
                        />
                    </a>
                    <Typography variant="h6" className={classes.titleText}>
                        {title}
                    </Typography>
                    <Typography
                        variant="body1"
                        className={classes.subtitleText}
                    >
                        {subtitle}
                    </Typography>
                    <Button
                        className={classes.navigateButton}
                        href={pageUrl}
                        aria-label={buttonText}
                        variant="contained"
                        fullWidth
                        color="primary"
                        size="large"
                    >
                        {buttonText}
                    </Button>
                </>
            </Fade>
        </Box>
    )
}

export default EmptyCartBuyCardItem

EmptyCartBuyCardItem.prototype = {
    pageUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    imageTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
}
